module.exports = __webpack_public_path__ + "media/assets/icon_help-46b5853463309f1edf98321da66be134c6e0a4fa88ab176b056c00e9f456708a.svg";